import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-plus-as-tab',
	templateUrl:'./PlusAsTabPluginPage.html',
	styles: [],
	styleUrls:['./PlusAsTabPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class PlusAsTabPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_629 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>plus-as-tab</artifactId>
</dependency>
\`\`\``;
	mdContent_630 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:plus-as-tab:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_631 = `\`\`\`json
"plusastab": "^0.2.2"
"jquery-emulatetab": "^0.2.9"
\`\`\``;
	mdContent_632 = `\`\`\`java
// Plus-as-tab is auto-enabled on page body.
// To skip a specific field:
PlusAsTabPageConfigurator.setSkipComponent(submitButton);

// To use a custom key (e.g. numpad +):
var feature = new PlusAsTabFeature(myForm);
feature.setKey(107);
\`\`\``;
	mdContent_633 = `\`\`\`java
// Enable plus-as-tab on a component
PlusAsTabPageConfigurator.setOnComponent(myForm);

// Skip a specific field
PlusAsTabPageConfigurator.setSkipComponent(myField);

// Use feature with custom key
var feature = new PlusAsTabFeature(myComponent);
feature.setKey(13); // Enter key
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
